import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import { OrderSummaryDTO } from '@/types/OrderSummary';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const orderApi = createApi({
  reducerPath: 'orderApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: `Orders` }),
  tagTypes: ['Orders'],
  endpoints: builder => ({
    getCustomerOrders: builder.query<
      SuccessResponse<OrderSummaryDTO>,
      { page?: number; orderType?: string; orderId?: number }
    >({
      query: ({ page = 1, orderType = '', orderId = '' }) => ({
        url: '/GetCustomerOrders',
        params: { page, orderType, orderId },
      }),
      transformResponse: (response: SuccessResponse<OrderSummaryDTO>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['Orders'],
    }),
    searchOrders: builder.query<SuccessResponse<OrderSummaryDTO>, { page?: number; orderId?: string }>({
      query: ({ page = 1, orderId = '' }) => ({
        url: '/SearchOrders',
        params: { page, orderId },
      }),
      transformResponse: (response: SuccessResponse<OrderSummaryDTO>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
      providesTags: ['Orders'],
    }),
  }),
});

export const { useGetCustomerOrdersQuery, useSearchOrdersQuery } = orderApi;
